/**
 * 画像・動画遅延読み込み
 */
require('intersection-observer') // 遅延読み込みのpolyfill
import lozad from 'lozad'

export default function() {
  document.addEventListener(`DOMContentLoaded`, ()=>{
    const observer = lozad(`.js-lozad`, {
      rootMargin: `10%`
    })
    
    observer.observe()
  })
}
